// removed by extract-text-webpack-plugin
module.exports = {"stepPanel":"Options__stepPanel___3FvRD stepPanel__stepPanel___1Vrm5 layout__panel___vsQZV","embargoPeriod":"Options__embargoPeriod___yQbqu"};


//////////////////
// WEBPACK FOOTER
// ./src/options/components/Options.css
// module id = 764
// module chunks = 0